<template>
  <section class="our-causes">
    <div class="container">
      <div class="row">
        <div class="col-12">
          <div class="section-heading">
            <h2 class="entry-title">แคมเปญการบริจาคของเรา</h2>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <swiper
            class="swiper-container causes-slider"
            :modules="modules"
            :slides-per-view="numberSlide"
            :space-between="30"
            :loop="true"
            :navigation="{
              enabled: true,
              prevEl: '.swiper-button-prev',
              nextEl: '.swiper-button-next'
            }"
            :autoplay="{
              delay: 50000,
              disableOnInteraction: false
            }"
            :scrollbar="{ draggable: true }"
          >
            <swiper-slide v-for="item in Campaigns" :key="item.id">
              <div class="cause-wrap">
                <figure class="m-0">
                  <img
                    :src="getImageSource(item.BACKGROUND_PATH)"
                    alt="Campaign Background"
                    class="campaign-event"
                  />
                  <div
                    class="figure-overlay d-flex justify-content-center align-items-center position-absolute w-100 h-100"
                  >
                    <a :href="'/start-donate/' + item.ID" class="btn gradient-bg mr-2">บริจาค</a>
                  </div>
                </figure>
                <div class="cause-content-wrap content-size">
                  <header class="entry-header d-flex flex-wrap align-items-center">
                    <h4 class="entry-title w-100 m-0">
                      <a :href="'/about-campaign/' + item.ID">
                        <span class="event-title">{{ item.TITLE }}</span>
                      </a>
                    </h4>
                  </header>
                  <div class="entry-content">
                    <p class="m-0 campaign-detail">
                      <a :href="'/about-campaign/' + item.ID">
                        {{ item.DETAIL }}
                      </a>
                    </p>
                  </div>
                  <div class="fund-raised w-100">
                    <div class="fund-raised-bar-1 barfiller">
                      <div class="tipWrap">
                        <span class="tip"></span>
                      </div>
                      <span class="fill" data-percentage="83"></span>
                    </div>
                    <div
                      class="fund-raised-details d-flex flex-wrap justify-content-between align-items-center"
                    >
                      <div class="fund-raised-total mt-4">
                        ยอดบริจาค: {{ formatPrice(item.DONATIONAMOUNT) }} บาท
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </swiper-slide>
          </swiper>

          <div class="swiper-button-next">
            <span> <ButtonNextIcon /> </span>
          </div>
          <div class="swiper-button-prev">
            <span><ButtonPrevIcon /> </span>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
import { ref, onMounted, onUnmounted } from 'vue';
import { Navigation, Pagination, Scrollbar, A11y, Autoplay } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/vue';
import ButtonNextIcon from './icons/IconButtonNext.vue';
import ButtonPrevIcon from './icons/IconButtonPrev.vue';
import { formatPrice } from './scripts/utillities';
import { useCampaigns } from './scripts/useCampaigns';

const backend_url = import.meta.env.VITE_API_URL;

const { Campaigns } = useCampaigns();

const numberSlide = ref(3);
const windowWidth = ref(window.innerWidth);
const maxCharacter = ref(120);

const modules = [Navigation, Scrollbar, Pagination, A11y, Autoplay];

const getImageSource = (backgroundPath) => {
  if (backgroundPath === '') {
    return `${backend_url}/images/cause-1.jpg`;
  } else {
    return backend_url + backgroundPath;
  }
};

const onResize = () => {
  windowWidth.value = window.innerWidth;
  if (windowWidth.value < 450) {
    numberSlide.value = 2;
    maxCharacter.value = 30;
  } else {
    numberSlide.value = 3;
  }
};

onMounted(() => {
  window.addEventListener('resize', onResize);
  onResize(); // Call on initial mount
});

onUnmounted(() => {
  window.removeEventListener('resize', onResize);
});

</script>

<style scoped>
/* สำหรับ ข้อควมสองบรรทัด */
.campaign-detail {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.campaign-detail > a:link,
a:hover {
  text-decoration: none;
  color: inherit;
}
.content-size {
  min-height: 35vh;
}
@media (min-width: 1400px) {
  .container {
    max-width: 1140px;
  }
}
@media (max-width: 1024px) {
  .content-size {
    min-height: 25vh;
  }
}
.campaign-event {
  /* max-height: 200px; */
  aspect-ratio: 16/9;
}
.event-title {
  font-size: 1.05rem;
}

.swiper-button-next::after,
.swiper-button-prev::after {
  content: '';
}
</style>